export const BOOKING_TIME_CONFLICT = `C24E4C50-4C01-4685-A42B-2696996357A2`;
export const EDIT_PERMISSION_EXCEPTION = `849034C9-432E-4D3C-9E29-B7C5D22DB913`;
export const ENTITY_OUT_OF_DATE_EXCEPTION = `BC6133AB-1B39-4E61-9F49-51ED34986CF4`;
export const STATUS_DATE_CHANGE_EXCEPTION = `F4519054-5249-46E2-96C1-687E4F1CC25A`;
export const STATUS_PERMISSION_EXCEPTION = `03FAC27A-4174-4983-B07E-EFD37B1F965F`;
export const STATUS_TRANSITION_EXCEPTION = `49909C95-4125-42A1-924B-9DAF65CFEA15`;
export const INSUFFICIENT_PRIVELEGES_TO_CREATE_BOOKING_IN_THE_PAST_EXCEPTION = `1DA7C24E-C966-4184-BC1A-71D974874141`;



// WEBPACK FOOTER //
// ./scripts/constants/apiErrorCodes.js